import { Component, forwardRef, ChangeDetectionStrategy } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { NgClass } from '@angular/common';

import { BaseBtnGroupComponent } from '../base-btn-group';

@Component({
    selector: 'app-optimization-settings-tasks-duration-btn-group',
    templateUrl: './optimization-settings-tasks-duration-btn-group.component.html',
    styleUrls: ['./optimization-settings-tasks-duration-btn-group.component.scss'],
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => OptimizationSettingsTasksDurationBtnGroupComponent),
            multi: true
        }
    ],
    imports: [NgClass],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class OptimizationSettingsTasksDurationBtnGroupComponent extends BaseBtnGroupComponent {
    public readonly options: Array<number> = [-25, -15, -10, -5, 0, 5, 10, 15, 25];
}
